import React, { useEffect, useState } from "react";
import {
  Placements,
  Avatar,
  Button,
  StatusTags,
  Backdrop,
  LogoLoader,
  TableAdv,
  SmartTooltip,
} from "../../../../components/index";
import { mapTableRows } from "../../../../utils/mapTableRows";
// import generateVendors from "../../../../assets/data/generateVendor";

import { dateFormator } from "../../../../utils/dateFormator";
// import { vendorData } from "../../../../assets/data/candidatesData";
import {
  clearVendorData,
  getVendorsStart,
} from "../../../../redux/slices/vendor/vendorSlice";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import { Link } from "react-router-dom";
import { getVendorId } from "../../../../utils/getClientId";

// const newCandidatesData = vendorData.map((item, index) => ({
//   id: index + 1,
//   ...item,
// }));

const AllVendors = () => {
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const { loading, error, vendors, totalCount } = useSelector(
    (state) => state.vendor,
  );

  const isLoading = loading;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(
        getVendorsStart({
          page: newPage,
          limit: newLimit,
          filters: {
            search: { type: "SEARCH", value: searchValue },
          },
          ret: "uiid businessName generalInfo.recordStatus generalInfo.netTerms  consultants",
          sort: { uiid: -1 },
          ref: "PlacementWithEmp",
          incl: "employeeId jobInfo.startDate jobInfo.jobTitle",
        }),
      );
    },
  );
  const tableData = vendors?.data || []; // Add null check with default empty array
  // const tableData = generateVendors(160);

  const handleEdit = (row) => {
    alert(row.slno);
  };

  const columns = [
    // { key: "slno", label: "Sl No" },
    {
      key: "businessName",
      label: "Business Name",
      width: "min-w-[250px]! max-w-[350px]!",
      render: (row) => (
        <SmartTooltip
          description={row.businessName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <Link to="/vendor/vendor-details" state={{ code: row.uiid }}>
            <div className="flex items-center gap-2">
              <Avatar
                alt={row.businessName}
                size="sm"
                outline
                src={row.profileImage}
              />
              <span className="text-linkblue line-clamp-1!">
                {row.businessName}
              </span>
            </div>
          </Link>
        </SmartTooltip>
      ),
    },
    {
      key: "vendorId",
      label: "Vendor ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="text-linkblue">
            <Link to="/vendor/vendor-details" state={{ code: row.uiid }}>
              {getVendorId(row.uiid)}
            </Link>
          </span>
        </div>
      ),
    },

    {
      key: "netTerms",
      label: "Net Terms",
      render: (row) => (
        <Link to="/vendor/vendor-details" state={{ code: row.uiid }}>
          <div className="flex items-center gap-1">
            <span className="">
              {/* <span className="text-linkblue"> */}
              {row.generalInfo?.netTerms || "-"}
            </span>
          </div>
        </Link>
      ),
    },
    {
      key: "employeeStatus",
      label: "Status",
      render: (row) => (
        <Link to="/vendor/vendor-details" state={{ code: row.uiid }}>
          <StatusTags
            tag={row.generalInfo?.recordStatus === 1 ? "Active" : "Inactive"}
          />
        </Link>
      ),
    },
    // {
    //   key: "contactNo",
    //   label: "Contact No",
    //   render: (row) => (
    //     <div className="flex items-center gap-1">
    //       <span className="">
    //         {/* <span className="text-linkblue"> */}
    //         {row.contact?.code && row.contact?.number
    //           ? row.contact?.code + "-" + row.contact?.number
    //           : "-"}
    //       </span>
    //     </div>
    //   ),
    // },
    // {
    //   key: "emailId",
    //   label: "Email ID",
    //   render: (row) => (
    //     <div className="flex items-center gap-1">
    //       <span className="">
    //         {/* <span className="text-linkblue"> */}
    //         {row.email}
    //       </span>
    //     </div>
    //   ),
    // },
    {
      key: "activePlacements",
      label: "Active Placements",
      //name(fn + ln) email jobtitle phone joiningdate
      render: (row) => (
        // from sir - not ready due to its not mapped
        <Placements
          // data={row.consultants
          //   ?.filter((placement) => {
          //     const endDate = new Date(placement?.jobInfo?.endDate);
          //     const today = new Date();
          //     return !placement?.jobInfo?.endDate || endDate >= today;
          //   })
          //   .map((place) => ({
          //     name:
          //       place?.employeeId?.firstName +
          //         " " +
          //         place?.employeeId?.lastName || "-",
          //     email: place?.employeeId?.email?.primary || "-",
          //     jobtitle: place?.jobInfo?.jobTitle || "-",
          //     phone: place?.employeeId?.mobile?.primary?.number || "-",
          //     joiningDate: dateFormator(place?.jobInfo?.startDate) || "-",
          //   }))}
          data={Array.from(
            new Map(
              row.consultants
                ?.filter((placement) => {
                  const endDate = new Date(placement?.jobInfo?.endDate);
                  const today = new Date();
                  return !placement?.jobInfo?.endDate || endDate >= today;
                })
                .map((place) => [
                  place.uiid,
                  {
                    name:
                      place?.employeeId?.firstName +
                        " " +
                        place?.employeeId?.lastName || "-",
                    email: place?.employeeId?.email?.primary || "-",
                    jobtitle: place?.jobInfo?.jobTitle || "-",
                    phone: place?.employeeId?.mobile?.primary?.number || "-",
                    joiningDate: dateFormator(place?.jobInfo?.startDate) || "-",
                  },
                ]),
            ).values(),
          )}
          columnData={[
            // "id",
            // {
            //   key: "joiningDate",
            //   label: "Joining Date",
            //   render: (row) => dateFormator(row.joiningDate, "short"),
            // },
            {
              key: "name",
              label: "Name",
            },
            {
              key: "email",
              label: "Email",
            },
            {
              key: "jobtitle",
              label: "Job Title",
            },
            {
              key: "phone",
              label: "Phone",
            },
            {
              key: "joiningDate",
              label: "Joining Date",
            },
          ]}
          modalTitle="Active Placements"
        />
      ),
    },

    {
      key: "",
      label: "Action",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="filter_alt"
          size="sm"
          color="black"
          onClick={() => handleEdit(row)}
        />
      ),
      sortable: false,
    },
  ];

  // Fix the data mapping to preserve all row properties
  const mappedRows = mapTableRows(tableData, columns);
  useEffect(() => {
    dispatch(
      getVendorsStart({
        page: page,
        limit: limit,
        filters: {
          search: { type: "SEARCH", value: searchValue },
        },
        sort: { uiid: -1 },
        ret: "uiid businessName generalInfo.recordStatus generalInfo.netTerms  consultants",
        ref: "PlacementWithEmp",
        incl: "employeeId jobInfo.startDate jobInfo.jobTitle",
      }),
    );
    return () => {
      dispatch(clearVendorData());
    };
  }, [dispatch, page, limit, searchValue]); // Empty array will cause it to run once when the component mounts

  const handleSearch = (keyname, value) => {
    setSearchValue(value);
  };

  return (
    <div className="flex flex-col overflow-hidden">
      {/* <div>
        <div className="flex gap-3 items-center py-4">
         
          <span>{(page - 1) * limit + 1} ----</span>
          <span>- {Math.min(page * limit, totalCount.data)} of </span>
          <span>{totalCount.data}</span>
          <Button
            type="icon"
            variant="text"
            color="black"
            icon="chevron_left"
            onClick={() => setPage((prev) => prev - 1)}
            disabled={page === 1}
          />
          <Button
            icon="chevron_right"
            type="icon"
            variant="text"
            color="black"
            onClick={() => setPage((prev) => prev + 1)}
            disabled={page >= Math.ceil(totalCount.data / limit)}
          />
          <FormFieldSet
            title=""
            type="select"
            options={options}
            value={limit}
            onChange={handleLimitChange}
          />
        </div>
        <ul>
          {tableData.map((row, index) => (
            <li key={index}>
              {getClientId(row.uiid)} - {row.businessName}
            </li>
          ))}
        </ul>
      </div> */}
      <TableAdv
        tableId={`vendors_allvendors`}
        rows={mappedRows}
        columns={columns}
        showSlNo
        //
        serverPagination={true}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        serverSerchValue={searchValue}
        serverOnSearch={handleSearch}
        toolbarRight={{
          search: true,
          filter: true,
          download: true,
        }}
      />
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AllVendors;
